import { Component, h, Prop, Element, State, Event, EventEmitter } from '@stencil/core';
import { TIcon } from '../../../../components';

@Component({
  tag: 'dc-ui-header-flyout-nav-item',
  styleUrl: 'dc-ui-header-flyout-nav-item.scss',
  shadow: true,
})
export class DcUiHeaderFlyoutNavItem {
  @Element() el!: HTMLElement;
  @Prop() label!: string;
  @Prop() icon?: TIcon;
  @Prop() selected?: boolean;
  @State() isOpen: boolean = false;

  @Event({ bubbles: true, composed: true }) dcSubitemSelect!: EventEmitter<{
    origin: 'click' | 'keydown';
    label: string;
    selected: boolean;
    event: Event;
    level: number | string;
  }>;

  private hasSlotContent = false;

  componentWillLoad() {
    const slotElement = this.el.children;
    this.hasSlotContent = slotElement.length > 0;
  }

  private handleClick = (event: MouseEvent) => {
    this.dcSubitemSelect.emit({
      origin: 'click',
      label: this.label,
      selected: this.selected,
      event,
      level: this.getCurrentLevel(),
    });
  };

  private handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      this.dcSubitemSelect.emit({
        origin: 'keydown',
        label: this.label,
        selected: this.selected,
        event,
        level: this.getCurrentLevel(),
      });
    }
  };

  private getCurrentLevel = (): number | string => {
    // get the level of the current item if possible
    const menuContainer = this.el.closest('.menu-container');
    let level: number | string = 'unknown';
    if (menuContainer) {
      level = menuContainer.getAttribute('data-nav-level');
    }
    return level;
  };

  render() {
    const hasNextLevel = this.hasSlotContent;

    return (
      <li
        class={{
          'flyout-nav-item': true,
          'has-next-level': hasNextLevel,
          selected: this.selected,
          'is-open': this.isOpen,
        }}>
        <button
          class="flyout-nav-item-trigger"
          onClick={this.handleClick}
          onKeyDown={this.handleKeyDown}>
          {this.icon && (
            <dc-ui-icon
              color="darkBlue02"
              name={this.icon}
              size="medium"
              class="item-icon"
            />
          )}
          <span class="item-title">{this.label}</span>
          {hasNextLevel && (
            <dc-ui-icon
              color="darkBlue02"
              name="dc_forward_right"
              size="tiny"
              class="item-arrow"
            />
          )}
        </button>
        {hasNextLevel && (
          <div class="flyout-nav-item-content">
            <slot />
          </div>
        )}
      </li>
    );
  }
}
